import { RolesBulkActions } from "./types";

export const BULK_ACTION_RESULTS_TITLE: Record<RolesBulkActions, string> = {
  [RolesBulkActions.Delete]: "Delete roles results",
};

export const BULK_ACTION_NAMES: Record<RolesBulkActions, string> = {
  [RolesBulkActions.Delete]: "Delete",
};
